/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_PlaceholderInputs */

const en_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email address`)
};

const es_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico`)
};

const fr_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse e-mail`)
};

const de_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse`)
};

const ja_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレス`)
};

const zh_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电子邮箱地址`)
};

const ar_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عنوان البريد الإلكتروني`)
};

const id_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat email`)
};

const it_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indirizzo e-mail`)
};

const ru_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электронная почта`)
};

const pt_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de e-mail`)
};

const ko_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소`)
};

/**
* | output |
* | --- |
* | "Email address" |
*
* @param {Auth_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_email_placeholder = /** @type {((inputs?: Auth_Email_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_email_placeholder(inputs)
	if (locale === "es") return es_auth_email_placeholder(inputs)
	if (locale === "fr") return fr_auth_email_placeholder(inputs)
	if (locale === "de") return de_auth_email_placeholder(inputs)
	if (locale === "ja") return ja_auth_email_placeholder(inputs)
	if (locale === "zh") return zh_auth_email_placeholder(inputs)
	if (locale === "ar") return ar_auth_email_placeholder(inputs)
	if (locale === "id") return id_auth_email_placeholder(inputs)
	if (locale === "it") return it_auth_email_placeholder(inputs)
	if (locale === "ru") return ru_auth_email_placeholder(inputs)
	if (locale === "pt") return pt_auth_email_placeholder(inputs)
	return ko_auth_email_placeholder(inputs)
});